import { render, staticRenderFns } from "./CastLive.vue?vue&type=template&id=af40607a&scoped=true&"
import script from "./CastLive.vue?vue&type=script&lang=js&"
export * from "./CastLive.vue?vue&type=script&lang=js&"
import style0 from "./CastLive.vue?vue&type=style&index=0&id=af40607a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af40607a",
  null
  
)

export default component.exports